import React from "react"
import { OutboundLink } from "gatsby-plugin-google-gtag"

const BookDemoLink = ({ className }) => (
/*  <OutboundLink
    className={className}
    href="www.getinfer.io"
    aria-label="Go to Book a Demo page"
  >
    Book Demo
  </OutboundLink>*/
  null
)

export default BookDemoLink
